import Axios from 'axios'
import Store from '@/vuex/store'

let endpoint_config = process.env.VUE_APP_ENDPOINT + process.env.VUE_APP_CONFIG_API,
    api,
    endpoints = {
       config: endpoint_config
    }

// notifications
function send_notification(error)
{
    let callback = function() {
        return window.console.log('Nessuna azione prevista')
    }

    let data = error.response.data
    if(data == ''){
      // errore non gestito lato server (es. PHP FATAL ERROR)
      data = {}
      data.routerPush = 'homepage'
    }
    data.status = (error.response.status)? error.response.status : ''
    data.callback = callback
    window.eventBus.$emit('gotNotification',data)
    return error.response
}

export function test_notification(queryParameters)//test http errors
{
    let promise = Axios.post(endpoints.testNotifications, {httpStatusCode: queryParameters.httpCode})
    // comportamenti da gestire a livello api.js (es. send_notification)
    promise
        .then(
            () => {
                window.console.log('[api.js] - success')
            },
            (error) => {
                window.console.log('[api.js] - error')
                send_notification(error)
            }
        )
    // altri comportamenti da gestire a livello di componente, con callback dedicati ( -> un'altra .then() )
    return promise
}
    
export function get_config(token)
{
    api = Axios.create({
        headers: {
            //'Authorization': 'Bearer ' + token,
            post: {},
            get: {}
        }
    })
    let params = {'token': token}
    return api.post(
            endpoints.config,
            params,
        )
        .then((response) => {
            endpoints = response.data.endpoints
            endpoints.config = endpoint_config
            return response.data;
        }, (error) => {
            window.console.log(error)
        })
}

export function post_request(payload)
{
    let params = set_axios_parameters(payload)
    return api.post(
        endpoints.postRequest,
            params
        )
        .then((response) => {
            return response.data;
        }, (error) => {
            window.console.log('post_request error')
            window.console.log(error)
            return send_notification(error)
        })
}

export function post_review(payload)
{
    let params = JSON.stringify(payload)
    return api.post(
            endpoints.postReview,
            params
        )
        .then((response) => {
            return response.data;
        }, (error) => {
            window.console.log('send_review error')
            window.console.log(error)
            return send_notification(error)
        })
}

export function get_review(payload)
{
    let params = set_axios_parameters(payload)
    return api.post(
            endpoints.getReview,
            params
        )
        .then((response) => {
            return response.data;
        }, (error) => {
            window.console.log('get_request error')
            window.console.log(error)
            return send_notification(error)
        })
}

export function get_review_by_travel_review_id(payload)
{
  let params = set_axios_parameters(payload)
  return api.post(
    endpoints.getReviewByTravelReviewId,
    params
  )
    .then((response) => {
      return response.data;
    }, (error) => {
      window.console.log('get_request error')
      window.console.log(error)
      return send_notification(error)
    })
}

export function search(payload)
{
    let params = set_axios_parameters(payload)
    return api.post(
            endpoints.search,
            params
        )
        .then((response) => {
            return response.data;
        }, (error) => {
            window.console.log('search error')
            window.console.log(error)
            return send_notification(error)
        })
}

export function posts(payload)
{
    let params = set_axios_parameters(payload)
    return api.post(
            endpoints.posts,
            params
        )
        .then((response) => {
            return response.data;
        }, (error) => {
            window.console.log('posts error')
            window.console.log(error)
            return send_notification(error)
        })
}

export function details(payload)
{
    let params = set_axios_parameters(payload)

    let promise = api.post(
            endpoints.details,
            params
        )

    promise
        .then(
          () => {

          },

          (error) => {
              window.console.log('details error')
              window.console.log(error)
              return send_notification(error)
          }
        )

    return promise
}

export function checkout(payload)
{
    let params = set_axios_parameters(payload),
        promise = api.post(
            endpoints.checkout,
            params
        )

    promise
        .then(
            () => {
                window.console.log('[api.js] - checkout success')
            },
            (error) => {
                window.console.log('checkout error')
                window.console.log(error)
                return send_notification(error)
            }
        )

    return promise
}

export function confirm(payload)
{
    let params = set_axios_parameters(payload)
    return api.post(
            endpoints.confirm,
            params
        )
        .then((response) => {
            return response.data;
        }, (error) => {
            window.console.log('confirm error')
            window.console.log(error)
            return send_notification(error)
        })
}

export function request_send_access_link(payload)
{
    let params = set_axios_parameters(payload),
        promise = api.post(
            endpoints.requestSendAccessLink,
            params
        )

    promise.then(
            () => {
                window.console.log('[api.js] - request_send_access_link success')
            },
            (error) => {
                window.console.log('request_send_access_link error')
                window.console.log(error)
                return send_notification(error)
            })

    return promise
}


export function get_messages(payload)
{
  let params = set_axios_parameters(payload),
    promise = api.post(
      endpoints.getMessages,
      params
    )

  promise.then(
    () => {
      window.console.log('[api.js] - get_messages success')
    },
    (error) => {
      window.console.log('get_messages error')
      window.console.log(error)
      return send_notification(error)
    })

  return promise
}

export function post_message(payload)
{
  let params = set_axios_parameters(payload),
      promise = api.post(
        endpoints.postMessage,
        params
      )

  promise.then(
    () => {
      window.console.log('[api.js] - post_message success')
    },
    (error) => {
      window.console.log('post_message error')
      window.console.log(error)
      return send_notification(error)
    })

  return promise
}


export function get_faqs()
{
  let params = set_axios_parameters({}),
    promise = api.post(
      endpoints.getFaqs,
      params
    )

  promise.then(
    () => {
      window.console.log('[api.js] - get_faqs success')
    },
    (error) => {
      window.console.log('get_faqs error')
      window.console.log(error)
      return send_notification(error)
    })

  return promise
}

export function pl_get(payload)
{
  let params = set_axios_parameters(payload),
    promise = api.post(
      endpoints.paymentsLink.get,
      params
    )

  promise.then(
    () => {
      window.console.log('[api.js] - pl_get success')
    },
    (error) => {
      window.console.log('pl_get error')
      window.console.log(error)
      return send_notification(error)
    })

  return promise
}

export function pl_buy(payload)
{
  let params = set_axios_parameters(payload),
    promise = api.post(
      endpoints.paymentsLink.buy,
      params
    )

  promise.then(
    () => {
      window.console.log('[api.js] - pl_get success')
    },
    (error) => {
      window.console.log('pl_get error')
      window.console.log(error)
      return send_notification(error)
    })

  return promise
}

export function stripeCreateIntentClientSecret(payload)
{
  let params = set_axios_parameters(payload),
    promise = api.post(
      endpoints.stripeCreateIntentClientSecret,
      params
    )

  promise.then(
    () => {
      window.console.log('[api.js] - stripeCreateIntentClientSecret success')
    },
    (error) => {
      window.console.log('stripeCreateIntentClientSecret error')
      window.console.log(error)
      return send_notification(error)
    })

  return promise
}

function set_axios_parameters(parameters)
{
    return JSON.stringify({
        ...parameters,
        token: Store.state.token,
    })
}